<template>
    <component :is="sectionComponent" padding-top="10px" padding-bottom="10px">
        <component
            :is="textComponent"
            font-family="'Arial', 'Helvetica', 'sans-serif'"
            line-height="18px"
            font-size="13px"
            color="#4A4A4A"
        >
            Data: {{ date }}<br />
            Laikas: {{ time }}<br />
            Terminalo numeris: {{ terminalId }}<br />
            Sekimo numeris: {{ traceCode }}<br />
        </component>

        <component :is="hrComponent" border-color="#D7DFE2" border-width="1px"></component>

        <component
            :is="textComponent"
            font-family="'Arial', 'Helvetica', 'sans-serif'"
            line-height="18px"
            font-size="13px"
            color="#4A4A4A"
        >
            Sąskaitos numeris: {{ transactionId }}<br />
            Suma: {{ value }}<br />
            Serijos numeris: {{ serial }}
        </component>

        <component :is="hrComponent" border-color="#D7DFE2" border-width="1px"></component>

        <component
            :is="textComponent"
            font-family="'Arial', 'Helvetica', 'sans-serif'"
            line-height="18px"
            font-size="13px"
            color="#4A4A4A"
        >
            PIN kodas = grynieji pinigai! Niekada neatskleiskite PIN kodo telefonu.
        </component>

        <component :is="hrComponent" border-color="#D7DFE2" border-width="1px"></component>

        <component
            :is="textComponent"
            font-family="'Arial', 'Helvetica', 'sans-serif'"
            line-height="18px"
            font-size="13px"
            color="#4A4A4A"
        >
            <p>Mokėjimas internetu</p>
            <ul>
                <li>Pasirinkite paysafecard mokėjimo būdą internetinėje parduotuvėje;</li>
                <li>Įveskite 16 skaitmenų PIN kodą.</li>
            </ul>

            Dėmesio: Nenaudokite paysafecard kaip mokėjimo būdo kompiuterio atrakinimui ar tariamai laimėto prizo
            patvirtinimui.<br />
            Daugiau informacijos rasite adresu:
            <a target="_blank" href="https://www.paysafecard.com/security">www.paysafecard.com/security</a><br />
        </component>

        <component :is="hrComponent" border-color="#D7DFE2" border-width="1px"></component>

        <component
            :is="textComponent"
            font-family="'Arial', 'Helvetica', 'sans-serif'"
            line-height="18px"
            font-size="13px"
            color="#4A4A4A"
        >
            <strong>Pagalba</strong><br />
            <a target="_blank" href="https://www.paysafecard.com/help">www.paysafecard.com/help</a><br />
            paysafecard yra mokėjimo būdas sukurtas ir administruojamas
            <strong>Paysafe Prepaid Services Ltd.</strong> Bendra informacija ir sąlygos interneto svetainėje
            <a target="_blank" href="https://www.paysafecard.com">www.paysafecard.com</a>
        </component>

        <component :is="hrComponent" border-color="#D7DFE2" border-width="1px"></component>

        <component
            :is="textComponent"
            font-family="'Arial', 'Helvetica', 'sans-serif'"
            line-height="18px"
            font-size="13px"
            color="#4A4A4A"
        >
            Mėgaukitės pramogomis internete!
        </component>
    </component>
</template>

<script>
export default {
    props: ['isEmail', 'value', 'code', 'serial', 'terminalId', 'traceCode', 'date', 'time', 'transactionId'],

    computed: {
        sectionComponent() {
            return this.isEmail ? 'mj-section' : 'div';
        },

        textComponent() {
            return this.isEmail ? 'mj-text' : 'div';
        },

        hrComponent() {
            return this.isEmail ? 'mj-divider' : 'hr';
        },
    },
};
</script>
